import React from 'react';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;
`;

export const Loading = () => <Container>One moment...</Container>;
